import { useCallback, useEffect, useMemo, useRef } from 'react'
import { DocumentStore } from '../documents/DocumentStore'
import { OpenAPIDocument } from '../documents/OpenAPIDocument'
import { SpectralRulesetDocument } from '../documents/SpectralRulesetDocument'
import { IssuesStore } from '../issues/IssueStore'
import debounce from 'lodash.debounce'

export function useRunSpectralLint() {
  const workerRef = useRef<Worker | null>(null)

  useEffect(() => {
    workerRef.current = new Worker(
      /* webpackChunkName: "run-spectral-lint-worker" */ new URL('./runSpectralLint.ts', import.meta.url)
    )
    workerRef.current.onmessage = (event) => {
      console.log('run-spectral-lint-worker completed')
      IssuesStore.shared().dispatchChange()
    }
    workerRef.current.onerror = (event) => console.error(`run-spectral-lint-worker failed: ${event.error}`)
    return () => {
      workerRef.current?.terminate()
    }
  }, [])

  const runSpectralLint = useCallback(async () => {
    const documents = DocumentStore.shared().getDocuments()

    let openAPIFileHandles: Record<string, FileSystemFileHandle> = {}
    let spectralRulesetFileHandles: Record<string, FileSystemFileHandle> = {}
    for (const document of Object.values(documents)) {
      if (document instanceof OpenAPIDocument) {
        openAPIFileHandles[document.path] = document.fileHandle
      } else if (document instanceof SpectralRulesetDocument) {
        spectralRulesetFileHandles[document.path] = document.fileHandle
      }
    }

    workerRef.current?.postMessage({ openAPIFileHandles, spectralRulesetFileHandles })
  }, [workerRef])

  const debouncedRunSpectralLint = useMemo(() => {
    return debounce(runSpectralLint, 1000)
  }, [runSpectralLint])

  useEffect(() => {
    ;() => debouncedRunSpectralLint.cancel()
  }, [debouncedRunSpectralLint])

  return debouncedRunSpectralLint
}
